// "This tab signed out": read by bootstrap (and kept until the person clicks Sign in), so the page the pool's /logout returns to
// shows a signed-out screen instead of signing straight back in. pas-auth does not end the
// Microsoft session (IDPSignout is off), so an automatic sign-in would complete silently and the
// same person would be back in.

/** Namespaced like the app's other keys; set AFTER clearAppSession, which removes `hearingaid.*`. */
export const SIGNED_OUT_KEY = 'hearingaid.signedOut'

export function markSignedOut(storage: Storage): void {
  try {
    storage.setItem(SIGNED_OUT_KEY, '1')
  } catch {
    // blocked storage: the page after sign-out signs in again, as before
  }
}

export function clearSignedOut(storage: Storage): void {
  try {
    storage.removeItem(SIGNED_OUT_KEY)
  } catch {
    // nothing to do
  }
}

/**
 * True after a sign-out in this tab, until the person clicks Sign in (`signInAgain` clears it) or
 * a signed-in user is found. Reading does not forget it: a reload of the signed-out screen, or
 * the next person at this tab, must not be signed in silently with the still-open Microsoft session.
 */
export function isSignedOut(storage: Storage): boolean {
  try {
    return storage.getItem(SIGNED_OUT_KEY) !== null
  } catch {
    return false
  }
}
